const GOOGLE_ADS_ID = "AW-791964145";
const GOOGLE_ATC_SEND_TO = "AW-791964145/LCZ-CKWrjKIcEPHT0fkC";
const GOOGLE_OTP_SEND_TO = "AW-791964145/48MjCKKrjKIcEPHT0fkC";

const isBrowser = typeof window !== "undefined";

function runCallback(url) {
  if (url) {
    window.location = url;
  }
}

export function trackGoogleAdsConversion(sendTo, url) {
  if (!isBrowser || typeof window.gtag !== "function") {
    if (url) runCallback(url);
    return false;
  }

  window.gtag("event", "conversion", {
    send_to: sendTo,
    event_callback: () => runCallback(url),
  });

  return false;
}

export function trackAtcConversion(url) {
  return trackGoogleAdsConversion(GOOGLE_ATC_SEND_TO, url);
}

export function trackOtpConversion(url) {
  return trackGoogleAdsConversion(GOOGLE_OTP_SEND_TO, url);
}

export { GOOGLE_ADS_ID, GOOGLE_ATC_SEND_TO, GOOGLE_OTP_SEND_TO };
